import React, { Component } from 'react';
import PracticeListRoot from './PracticeListRoot'
import DisplayNumber from './containers/DisplayNumber'
import { Link, Route, Switch, BrowserRouter as Router } from "react-router-dom"
import { Image, Layout, Input, Menu, Breadcrumb, Col, Row, message, DatePicker } from 'antd';
import { CalendarOutlined, CloseOutlined, CheckOutlined, SearchOutlined } from '@ant-design/icons';
import { Divider, Card,  Button,  Checkbox, Progress, Spin, Table, Tag, Space } from 'antd';
import { Typography, Form } from 'antd';
import { DownloadOutlined, ProfileOutlined } from '@ant-design/icons';
import {store} from './store'
import axios from 'axios'

const { RangePicker } = DatePicker;
const { TextArea } = Input;

const { Title } = Typography;
const { Header, Content, Footer } = Layout;
const DOMAIN_COLORS = { BS:'#13c2c2', CD:'#f5222d', CSIA:'#5468ff', MAH:'#52c41a', OHPH:'#722ed1', SC:'#faad14', VP:'#a0d911', CAC:'#37e4e4' };

export default class ExtractPage extends Component{

  formRef = React.createRef()

  state = {
    data:[],
    portfolio_data:[],
    session: this.props.session,
    submitting: false,
    loading: true,
    filteredInfo: {},
    dateRange: null,
  }
  professor_comment_required = false
  componentWillMount() {
    if (!this.props.token) {
      // window.location.href='/'
    } 
  }
  componentDidMount() {
    let records = []
    let data = []
    axios('/record/list', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
    }).then( res => {
      records = res.data.records
      let selected_index = 0
      for (let i=0; i < records.length; i++) {
        let record = records[i]
        if (record.state == '승인완료') {
          let dict = {
            index: i,
            primary_class: record.primary_class,
            selected_index: selected_index,
            selection:'',
            start_at: record.start_at, 
            end_at: record.end_at, 
            institute: record.institute,
            content: record.practice,
            tags: record.competency.split(' '),
            professor: record.professor,
            state: record.state,
            id: record.id,
            checked:false
          }
          data.push(dict)
          selected_index += 1
        }
      }
      this.setState({
        ...this.state,
        data: data,
        loading: false,
      })

    });

    axios('/record/portfolio_list', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
    }).then( res => {
      const portfolios = res.data.portfolios
      const profs = res.data.profs
      let data =[]
      for (let i=0; i < portfolios.length; i++) {
        let pf = portfolios[i]
        let prof = profs[i]
        pf.professor = prof
        pf.index = i
        data.push(pf)
      }
      this.setState({
        ...this.state,
        portfolio_data: data
      })

    });


  }

  submitHandler = (e) => {
    this.setState({ submitting: true })
    axios('/record/submit_extract', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
      data: {
        ...e,
        professor_comment_required: this.professor_comment_required
      }
      }).then( res => {
        message.info('포트폴리오가 신청되었습니다')
        window.location.href='/extract'
      }).catch(() => {
        this.setState({ submitting: false })
      });
  }


  syncFormCheckboxIds = (data) => {
    const ids = data.filter(item => item.checked).map(item => item.id)
    if (this.formRef.current) {
      this.formRef.current.setFieldsValue({ checkbox_ids: ids })
    }
  }

  onSelectAll = (e) => {
    const checked = e.target.checked
    const newData = this.state.data.map(item => ({ ...item, checked }))
    this.setState({ data: newData }, () => this.syncFormCheckboxIds(newData))
  }

  onCheckOne = (index) => {
    const newData = [...this.state.data]
    newData[index] = { ...newData[index], checked: !newData[index].checked }
    this.setState({ data: newData }, () => this.syncFormCheckboxIds(newData))
  }

  domains = [
    ['BS', '기초생명의학 지식', '#13c2c2'],
    ['CD', '임상적 의사결정 능력', '#f5222d'],
    ['CSIA', '개별 동물에서의 건강과 질병 관리를 위한 임상 기술', '#5468ff'],
    ['MAH', '군집동물의 건강과 질병 관리', '#52c41a'],
    ['OHPH', '원헬스와 공중보건 전문성', '#722ed1'],
    ['SC', '학문과 연구', '#faad14'],
    ['VP', '수의전문직업성', '#a0d911'],
    ['CAC', '소통과 협력', '#37e4e4'],
  ]

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({ filteredInfo: filters })
  }

  getTextSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="검색"
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button type="primary" size="small" icon={<SearchOutlined />} onClick={() => confirm()}>검색</Button>
          <Button size="small" onClick={() => { clearFilters(); confirm() }}>초기화</Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    filteredValue: (this.state.filteredInfo || {})[dataIndex] || null,
    onFilter: (value, record) => record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : false,
  })

  getPracticeColumns = () => [
    {
      title: () => (
        <Checkbox
          onChange={this.onSelectAll}
          checked={this.state.data.length > 0 && this.state.data.every(item => item.checked)}
          indeterminate={this.state.data.some(item => item.checked) && !this.state.data.every(item => item.checked)}
        >
          전체
        </Checkbox>
      ),
      dataIndex: 'selected_index',
      key: 'selection',
      render: (index) => (
        <Checkbox checked={this.state.data[index].checked} onChange={() => this.onCheckOne(index)}></Checkbox>
      )
    },
    {
      title: '실습 분류',
      dataIndex: 'primary_class',
      key: 'primary_class',
      filters: [...new Set(this.state.data.map(d => d.primary_class).filter(Boolean))].sort()
        .map(v => ({ text: v, value: v })),
      filteredValue: (this.state.filteredInfo || {}).primary_class || null,
      onFilter: (value, record) => record.primary_class === value,
    },
    {
      title: '실습 날짜',
      dataIndex: 'selected_index',
      key: 'date',
      render: (index) =>
      this.state.data[index] ? <Link to={`/detail/${this.state.data[index].id}`} >{
        (new Date(this.state.data[index].start_at)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})
      } ~ {
        (new Date(this.state.data[index].end_at)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})
      }</Link> : '',
      filterDropdown: ({ setSelectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            value={this.state.dateRange}
            onChange={(dates) => {
              this.setState({ dateRange: dates })
              setSelectedKeys(dates ? [dates] : [])
            }}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button type="primary" size="small" icon={<SearchOutlined />} onClick={() => confirm()}>검색</Button>
            <Button size="small" onClick={() => { this.setState({ dateRange: null }); clearFilters(); confirm() }}>초기화</Button>
          </Space>
        </div>
      ),
      filterIcon: () => <CalendarOutlined style={{ color: this.state.dateRange ? '#1890ff' : undefined }} />,
    },
    {
      title: '실습 기관',
      dataIndex: 'institute',
      key: 'institute',
      ...this.getTextSearchProps('institute'),
    },
    {
      title: '실습 내용',
      dataIndex: 'content',
      key: 'content',
      ...this.getTextSearchProps('content'),
    },
    {
      title: '졸업 역량',
      key: 'tags',
      dataIndex: 'tags',
      filters: this.domains.map(([code, name, color]) => ({
        text: <span><span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', backgroundColor: color, marginRight: 6 }} />{code} - {name}</span>,
        value: code,
      })),
      filteredValue: (this.state.filteredInfo || {}).tags || null,
      render: tags => (
        <>
          {tags.map(tag => {
            const color = DOMAIN_COLORS[tag] || (tag.length > 5 ? 'geekblue' : 'green');
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: '승인 상태',
      dataIndex:'state',
      key: 'state',
    },
  ]


  portfolio_columns = [
    {
      title: '신청 날짜',
      dataIndex: 'index',
      key: 'date',
      render: (index) => 
      // console.log('index', this.state.data[index], index)


      this.state.portfolio_data[index] ? <Link to={`/portfolio_detail/${this.state.portfolio_data[index].id}`} >{
        (new Date(this.state.portfolio_data[index].createdAt)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})
      }
      </Link> : ''
    },
    {
      title: '선택 실습 수',
      dataIndex: 'record_ids',
      key: 'record_n',
      render: (record_ids) => record_ids? record_ids.length : ''
    },
    {
      title: '신청 용도',
      dataIndex: 'purpose',
      key: 'purpose',
      render: (purpose) => purpose
    },
    {
      title: '지도 교수',
      dataIndex: 'professor',
      key: 'professor',
      render: (professor) => professor
    },
    {
      title: '상태',
      key: 'status',
      dataIndex: 'status',
      render: status => 
          {
            const listType_to_status = {
              'waiting': '승인대기',
              'rejected': '반려',
              'done': '승인완료'
            }

            let status_kr = listType_to_status[status]
            let color
            if (status_kr === '반려') {
              color = 'volcano';
            } else if (status_kr == '승인완료'){
              color = 'blue'
            } else if (status_kr == '승인대기'){
              color = 'gray'
            }
            return (
              <Tag color={color} key={status}>
                {status_kr}
              </Tag>
            );
          }
    },
  ];

  onCheckChange = () => {
    this.professor_comment_required = !this.professor_comment_required
  }
  render(){
      if (this.state.loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}><Spin size="large" tip="로딩 중..." /></div>
      }
      return (
          // <Row style={{  margin:'50px'}}>
          <Form onSubmit={this.submitHandler} onFinish={this.submitHandler}
          ref={this.formRef}
          >
            <Col  xs={{span:22, offset:1}}  
              sm={{span:20, offset:2}} 
              md={{span:20, offset:2}} 
              lg={{span:20, offset:2}} 
              xxl={{span:16, offset:4}} 

              style={{marginTop:'40px', }}
              // xl={{span:20, offset:2}} 
              // xxl={{span:20, offset:2}} 
            >
              {/* <Row className='table'>
                <Col>
                <Row className='label'> 개인정보 </Row>
                <Row className='row1'>
                  <Col flex='auto' className='col1'>
                    <Row className='row'>
                      <Col className='row_title' flex='150px'>
                        이름
                      </Col>
                      <Col className='row_content' flex='auto'>{this.state.session.name}</Col>
                    </Row>
                    <Row className='row'>
                      <Col className='row_title' flex='150px'>
                        학번
                      </Col>
                      <Col className='row_content' flex='auto'>{this.state.session.student_number}</Col>
                    </Row>
                    <Row className='row'>
                      <Col className='row_title' flex='150px'>
                        연락처
                      </Col>
                      <Col className='row_content' flex='auto'>{this.state.session.phone}</Col>
                    </Row>
                    <Row className='row'>
                      <Col className='row_title' flex='150px'>
                        지도교수 </Col>
                      <Col className='row_content' flex='auto'>{this.state.session.managing_professor} 교수</Col>
                    </Row>
                    <Row className='row'>
                      <Col className='row_title' flex='150px'>
                        비고
                      </Col>
                      <Col className='row_content' flex='auto'>{this.state.session.etc}</Col>
                    </Row>
                  </Col>
                  <Col flex='200px'>
                    <Row className='image_title' >
                      등록사진
                    </Row>
                    <Row >
                      <Image
                      className='profile_image'
                      src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                      />
                    </Row>
                  </Col>
                </Row>
                </Col>
              </Row> */}


                {/* <TestPage hi='' ></TestPage> */}
              <Card>
                <Row span={12}>
                  <Col>
                    <Title level={3}>신청된 포트폴리오 현황</Title>
                  </Col>
                </Row>
                <Row span={12}>
                  <Col span={24}>
                      <Table key='portfolio' columns={this.portfolio_columns} dataSource={this.state.portfolio_data} />
                  </Col>
                </Row>
              </Card>
              <Divider/>
              <Card>
                <Row span={12}>
                  <Col>
                    <Title level={3}>포트폴리오 실습 선택</Title>
                  </Col>
                </Row>
                <Row span={12}>
                  <Col span={24}>
                    <Form.Item name='checkbox_ids' hidden><Input /></Form.Item>
                    <Table columns={this.getPracticeColumns()} onChange={this.handleTableChange} dataSource={
                      this.state.data.filter(record => {
                        const fi = this.state.filteredInfo || {}
                        if (fi.tags && fi.tags.length > 0) {
                          if (!fi.tags.every(tag => record.tags.includes(tag))) return false
                        }
                        if (this.state.dateRange && this.state.dateRange[0] && this.state.dateRange[1]) {
                          const start = new Date(record.start_at)
                          const end = new Date(record.end_at)
                          const rangeStart = this.state.dateRange[0].startOf('day').toDate()
                          const rangeEnd = this.state.dateRange[1].endOf('day').toDate()
                          if (end < rangeStart || start > rangeEnd) return false
                        }
                        return true
                      })
                    } />
                  </Col>
                </Row>
                <Row>
                  <Col
                    flex='auto'
                  >
                    <Form.Item
                    name='introduction'
                    >
                      <TextArea size="large"
                      autoSize={{ minRows: 3, maxRows: 20 }}
                      name='purpose'
                      placeholder="포트폴리오 자기소개 (포트폴리오 양식에 기재되는 내용으로, 작성하지 않아도 포트폴리오 신청은 가능합니다)" prefix={<ProfileOutlined />} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col
                    flex='auto'
                  >
                    <Form.Item
                    name='purpose'
                    rules={[{ required: true, message: '포트폴리오 용도를 입력하세요'}]}
                    >
                      <TextArea size="large"
                      autoSize={{ minRows: 3, maxRows: 20 }}
                      name='purpose'
                      placeholder="포트폴리오 용도 (지도교수에게 공개됩니다)" prefix={<ProfileOutlined />} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col
                    flex='auto'
                  >
                    <Form.Item 
                    name='professor_comment_required'
                    >
                    <Checkbox name='professor_comment_required' size='large'
                    value={this.professor_comment_required}
                    onChange={this.onCheckChange}
                    >포트폴리오에 지도교수 코멘트 요청(선택사항)</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Divider/>
                <Row>
                    <Form.Item noStyle >
                      <Button type="primary" block  size='large' htmlType='submit' loading={this.state.submitting} disabled={this.state.submitting}>
                        선택된 실습으로부터 포트폴리오신청
                      </Button>
                    </Form.Item>
                </Row>
              </Card>
              {/* <div className="site-layout-content">Content</div>
              <div className="site-layout-content"><DisplayNumber/></div> */}
            {/* </Row> */}

          </Col>
        </Form>
        )
    }
}